<template>
  <edit-modal
    caption="Bundel dupliceren"
    :isActive="isActive">
    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="withData">
            Tabelregels en content overnemen?
          </label>
      </div>
    </div>

    <save-buttons
      @save="proceed"
      @cancel="close">
    </save-buttons>
  </edit-modal>
</template>

<script>
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: {
    fromId: {
      type: Number,
      required: true,
      default: 0
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      withData: false
    }
  },
  methods: {
    proceed () {
      this.$emit('proceed', {
        fromId: this.fromId,
        withData: this.withData
      })

      this.close()
    },
    close () {
      this.withData = false
      this.$emit('close')
    }
  }
}
</script>
